export default "__VITE_ASSET__N54SPFOJ__"